/**
 * --------------------------------------------------------------------------
 * Ace (v2.1.4): index.umd.js
 * --------------------------------------------------------------------------
 */

import Util from './src/util'
import Basic from './src/general'
import Scrollbar from './src/scrollbar'
import Sidebar from './src/sidebar'
import Aside from './src/aside'
import Toaster from './src/toaster'
import Widget from './src/widget'
import FileInput from './src/fileinput'
import Wysiwyg from './src/wysiwyg'

export default {
  Util,
  Basic,
  Scrollbar,
  Sidebar,
  Aside,
  Toaster,
  Widget,
  FileInput,
  Wysiwyg
}
